import {Injectable, Inject} from "@angular/core";
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpXsrfTokenExtractor} from "@angular/common/http";
import {Observable} from "rxjs";
import {DOCUMENT} from "@angular/common";

@Injectable()
export class CSRFRequestInterceptor implements HttpInterceptor {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(@Inject(DOCUMENT) private doc: any, private tokenExtractor: HttpXsrfTokenExtractor) {}

  //function which will be called for all http calls
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const csrfTokenFromCookies = this.getTokenValueFromCookiesTokens();
    const token = csrfTokenFromCookies ? csrfTokenFromCookies : this.tokenExtractor.getToken();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const requestToForward: HttpRequest<any> = request.clone({
      setHeaders: {"X-CSRF-TOKEN": token !== null ? token : ""},
    });

    return next.handle(requestToForward);
  }

  private getTokenValueFromCookiesTokens(): string | null {
    let tokenValue = null;
    const cookiesCSRFToken = this.doc.cookie?.split(";").find((item) => item?.trim().startsWith("csrf_access_token="));

    if (cookiesCSRFToken) {
      tokenValue = cookiesCSRFToken.split("=")[1]?.trim();
    }

    return tokenValue;
  }
}
